import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { LoadingScreen } from '@/components/feedback/loading-screen';

// Lazy load public pages
const PublicFormPage = lazy(() => import('@/pages/forms/public'));
const PublicQuotePage = lazy(() => import('@/pages/public/quote'));

/**
 * Public form routes (no authentication required)
 */
export const publicFormRoutes = [
  {
    path: 'forms',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: ':slug',
        element: <PublicFormPage />,
      },
    ],
  },
  {
    path: 'public/quotes',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: ':token',
        element: <PublicQuotePage />,
      },
    ],
  },
];
